interface WordmarkProps {
  mobile?: boolean;
}

export default function Wordmark({ mobile = false }: WordmarkProps) {
  // Desktop wordmark sits on the dark auth-brand panel — use white variant.
  // Mobile wordmark sits on a light background — use the standard teal variant.
  const src = mobile ? "/logo-wordmark.png" : "/logo-wordmark-white.png";
  return (
    <span className={mobile ? "auth-mobile-wordmark" : "auth-wordmark"}>
      <img
        src={src}
        alt="Troughmate"
        height={mobile ? 18 : 22}
        style={{ display: "block", width: "auto" }}
      />
    </span>
  );
}
